import { createFileRoute, useParams } from "@tanstack/react-router";

import { ListPageV2 } from "@/features/ListsV2/components/ListPage";

export const Route = createFileRoute("/_auth/people/$siteId/lists/")({
  component: ListIndex,
});

function ListIndex() {
  const { siteId } = useParams({ from: "/_auth/people/$siteId/lists" });

  return <ListPageV2 siteId={siteId} />;
}
